<template>
    <v-dialog v-if="user === undefined" v-model="dialogVar" transition="dialog-bottom-transition" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn plain v-bind="attrs" v-on="on" style="font-weight: bold; color: black;">
                {{ $t('Přihlásit se') }}
            </v-btn>
        </template>
        <v-card dark class="logindialog">

            <div style="display: flex; width: 100%; justify-content: space-between;">
                <v-card-title style="margin-bottom: 12px;">{{ $t('Přihlášení') }}</v-card-title>

                    <div @click="dialogVar = false" class="esy-close-button" style="color: white !important; width: 32px; height: 32px; margin: 16px; display: flex; justify-content: center; align-items: center;">
                        <svg style="width: 24px; height: 24px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>

            </div>

            <v-card-text>
                <v-alert color="error" v-model="error">
                    {{ errorMessage }}
                </v-alert>

                <v-container @keyup.enter="logIn()" style="padding: 0;">
    
                    <v-text-field :label="$t('Email')" v-model="email" outlined required></v-text-field>
            
                    <v-text-field :label="$t('Heslo')" autocapitalize="off" autocorrect="off" spellcheck="false" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'fal fa-eye-slash' : 'fal fa-eye'" @click:append="showPassword = !showPassword" v-model="password" outlined required>
                    </v-text-field>
                
                    <reset></reset>

                </v-container>

                <div class="d-flex flex-column">
                    <v-btn color="green" @click="logIn()" :disabled="facebookLoading" :loading="loading" class=" font-weight-black">
                        {{ $t('Přihlásit se') }}
                    </v-btn>
                    <!--
                    <p class="text-center my-3">{{ $t('Nebo') }}</p>
                    <v-btn class="d-inline d-sm-none" color="#37639A" @click="facebook" :disabled="loading" :loading="facebookLoading">
                        <v-icon>fab fa-facebook</v-icon>
                    </v-btn>
                    <v-btn class="d-none d-sm-inline font-weight-black" color="#37639A" @click="facebook" :disabled="loading" :loading="facebookLoading">
                        {{ $t('Přihlásit se přes facebook') }}
                    </v-btn> -->
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
const { URL } = require("../../store/index");
import Reset from "../auth/Reset.vue";
import { registerForPush } from "../../push";

export default {
    components: {
        Reset,
    },

    data() {
        return {
            dialogVar: false,
            loading: false,
            facebookLoading: false,

            forceRedirect: true,

            email: "",
            password: "",
            showPassword: false,

            error: false,
            errorMessage: "",
        };
    },

    computed: {
        user() {
            return this.$store.state.user;
        },
    },

    mounted() {
        this.$root.$on("openLoginDialog", (forceRedirect = true) => {
            this.dialogVar = true;
            this.forceRedirect = forceRedirect;
        })
    },

    methods: {
        facebook() {
            this.facebookLoading = true;
            window.location.href = this.$store.getters["facebookLoginUrl"];
        },
        async logIn() {
            if (this.loading) return;

            if (!this.email || !this.password) {
                this.errorMessage = this.$t("Vyplňte prosím e-mail i heslo.");
                this.error = true;
                return;
            }

            this.loading = true;
            this.error = false;

            const result = await this.$store.dispatch("logIn", {
                email: this.email.trim(),
                password: this.password,
            });

            if (!result.ok && result.code === "not_activated") {
                // The account waits for its e-mail code: continue on the activation screen (it can also send a new code).
                this.loading = false;
                this.dialogVar = false;
                this.$router.push({ name: "Activation", params: { email: this.email.trim(), fromLogin: true } }).catch(() => {});
                return;
            }

            if (!result.ok) {
                this.loading = false;
                this.errorMessage = result.status === 400 && /kombinac/i.test(result.message)
                    ? this.$t('Takovou kombinaci e-mailu a hesla jsme nenašli. Zkus to prosím znovu.')
                    : result.message;
                this.error = true;
                return;
            }

            this.$store.dispatch("loadUser");
            // iOS: request push permissions and register for APNs
            try { registerForPush(this.$store); } catch (e) { console.error(e); }
            this.dialogVar = false;
            this.loading = false;


            window.history.replaceState(null, '', '/');

            if (this.forceRedirect) {
                if (this.$vuetify.breakpoint.smAndDown) {
                    this.$router.push({ name: "Home" });
                } else {
                    this.$router.push({ name: "Profile" });
                }
            }
        },
    },
};
</script>

<style>
.logindialog .v-btn {
    color: white;
    height: 50px !important;
}
.logindialog {
    background-color: #1e1e1e !important;
}

.esy-close-button:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, .25) !important;
}
</style>